import React from 'react';
import { Button } from '@shopify/polaris';

const FreeSubscriptionBlock = ({ type, sub, currentPlan, t }) => {
	const getDataForType = () => {
		switch (type) {
			case "vat":
				return {
					title: t("taxCorePages.dashboard.freePlans.vat"),
					price: t("taxCorePages.dashboard.free")
				};
			case "sales tax":
				return {
					title: t("taxCorePages.dashboard.freePlans.salesTax"),
					price: t("taxCorePages.dashboard.free")
				};
			case "epr":
				return {
					title: t("taxCorePages.dashboard.freePlans.epr"),
					price: t("taxCorePages.dashboard.free")
				};
			case "omp":
				return {
					title: t("taxCorePages.dashboard.freePlans.omp"),
					price: t("taxCorePages.dashboard.free")
				};
			case "invoice":
				return {
					title: t("taxCorePages.dashboard.freePlans.invoice"),
					price: t("taxCorePages.dashboard.free")
				};
			case "authorize":
				return {
					title: t("taxCorePages.dashboard.freePlans.authorize"),
					price: t("taxCorePages.dashboard.free")
				};
			default:
				return {
					title: t("taxCorePages.dashboard.freePlans.default"),
					price: t("taxCorePages.dashboard.free")
				};
		}
	};

	const { title, price } = getDataForType();

	return (
		<div className="free-subscription-block">
			<div className="subscription-label">
				{title}
			</div>
			<div className="subscription-price">
				${price}
			</div>
			<Button
				variant="primary"
				size="micro"
				onClick={() => window.location.href = '/subscription'}
			>
				{t("taxCorePages.dashboard.getPremium")}
			</Button>
		</div>
	);
};

export default FreeSubscriptionBlock;
